<style scoped>
.bookmark-container {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 40vh;
}
.pull-right {
  float: right;
}
</style>

<template>
  <mu-menu :open.sync="open">
    <mu-button flat>
      <mu-badge :content="bookmarkCount.toString()" :color="isPreview ? 'secondary' : 'primary'" circle>
        <mu-icon value="star"></mu-icon>
      </mu-badge>
    </mu-button>
    <div slot="content" ref="scroll" class="bookmark-container">
      <mu-list textline="two-line">
        <mu-sub-header>{{$t('BookmarkList.title')}}</mu-sub-header>
        <mu-list-item v-for="(item, index) in items" button @click="toRoute(item)">
          <mu-list-item-action>
            <mu-button icon>
              <mu-icon :value="iconType(item)"></mu-icon>
            </mu-button>
          </mu-list-item-action>
          <mu-list-item-content>
            <mu-list-item-title>
              <span v-if="item.type === 'media' || item.type === 'mediaMoment' || item.type === 'channel'">
                {{item.object && item.object.name ? item.object.name : ''}}
              </span>
              <span v-if="item.type === 'comment'">
                {{item.object && item.object.content ? item.object.content : ''}}
              </span>
            </mu-list-item-title>
            <mu-list-item-sub-title>
              <span v-if="item.type === 'mediaMoment'">
                {{item.reference && item.reference.startFrom ? timeString(item.reference.startFrom) : ''}}
              </span>
              <span v-if="item.type === 'comment'">
                {{item.reference && item.reference.name ? item.reference.name : ''}}
              </span>
            </mu-list-item-sub-title>
          </mu-list-item-content>
          <mu-list-item-action>
            <mu-button icon @click.stop.prevent="onClickDelete(item)">
              <mu-icon value="delete"></mu-icon>
            </mu-button>
          </mu-list-item-action>
        </mu-list-item>
        </transition-group>
        <mu-list-item v-if="items.length === 0">
          <mu-list-item-title>
            {{$t('BookmarkList.empty')}}
          </mu-list-item-title>
        </mu-list-item>
      </mu-list>
    </div>
  </mu-menu>
</template>

<script>
// Library
import axios from "axios";

import timeFormatter from '@/utils/timeFormatter.js'

import langEn from './lang/en.json'
import langZh from './lang/zh.json'

export default {
  name: 'BookmarkList',
  components: {
  
  },
  props: {

  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    authorized() {
      return this.$store.state.auth.authorized;
    },
    isPreview() {
      if(this.$store.getters.previewMode) {
        return true;
      } else {
        return false;
      }
    },
    bookmarkCount() {
      return this.items.length
    },
    items() {
      return this.$store.state.bookmarks;
    },
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$i18n.add('en', langEn); // Add English Translation
    this.$i18n.add('zh', langZh); // Add Traditional Chinese Translation
  },
  watch: {
    authorized(newValue) { // Watch on authorized
      if(newValue) {
        this.getData()
      }
    },
  },
  methods: {
    getData() {
      this.$store.dispatch('bookmarkList');
    },
    toRoute(item) {
      if(item.type === 'media') {
        this.$router.push({
          name: 'Media',
          params: {
            mediaId: item.id
          }
        });
      } else if(item.type === 'mediaMoment') {
        this.$router.push({
          name: 'MediaStartFrom',
          params: {
            mediaId: item.id,
            startFrom: item.reference.startFrom
          }
        });
      } else if(item.type === 'channel') {
        this.$router.push({
          name: 'Channel',
          params: {
            channelId: item.id
          }
        });
      } else if(item.type === 'comment') {
        this.$router.push({
          name: 'Media',
          params: {
            mediaId: item.reference._id
          }
        });
      } 
    },
    onClickDelete(item) {
      this.$store.dispatch('bookmarkDown', item);
    },
    iconType(item) {
      if(item.type === 'channel') {
        return 'subscriptions';
      } else if(item.type === 'media' || item.type === 'mediaMoment') {
        return this.iconMediaType(item.object.type);
      } else if(item.type === 'comment') {
        return 'chat';
      } else {
        return '';
      }
    },
    iconMediaType(type) {
      if(type == "video") {
        return 'movie';
      } else if(type == "img") {
        return "photo";
      } else if(type == "pdf") {
        return "insert_drive_file";
      } else if(type == "youtube") {
        return 'subscriptions';
      } else if(type == "wysiwyg") {
        return "text_format";
      } else if(type == "mp4link") {
        return "on_demand_video";
      } else if(this.isModelType(type) || type == 'model') {
        return 'layers';
      }
    },
    
    timeString(time) {
      return timeFormatter(time);
    },
  },
}
</script>
